import { buildApiUrl } from '../../configs/api.js'

export default {
  postUrl(payload) {
    const restaurantId = payload?.restaurantId || payload?.id
    if (!restaurantId) throw new Error('restaurantId is required for updating restaurant')
    
    return buildApiUrl('/restaurant/update/:restaurantId', { pathParams: { restaurantId } })
  },

  method: 'POST',

  format(payload) {
    const data = { ...payload }
    delete data.restaurantId
    delete data.id

    return data
  },

  parse(raw = {}) {
    if (raw?.statusCode !== 200) {
      return { 
        statusCode: raw?.statusCode || 400, 
        message: raw?.message || 'Erreur lors de la mise à jour', 
        data: null 
      }
    }
    return { 
      statusCode: 200, 
      message: 'Mise à jour réussie', 
      data: raw.data 
    }
  },
}
